const COMPANY_STATUS_CRM_FIELD = "UF_CRM_1401270463";

export { COMPANY_STATUS_CRM_FIELD };
